import request from '@/utils/request'

// 获取病区列表
export function getWardList() {
  return request({
    url: '/ward/list',
    method: 'get'
  })
}